import React from "react";
import "./ContactUs.css";
import { FaEnvelope, FaFacebookF, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import logo from "../assets/logo2.png";

const ContactUs = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">

        {/* HEADER */}
        <div className="contact-header">
          <h2>Контакт</h2>
          <div className="line"></div>
          <p>Контактирајте нè за повеќе информации или закажување термин</p>
        </div>

        <div className="contact-wrapper">

          {/* LEFT */}
          <div className="contact-info">

            {/* LOGO + NAME */}
            <div className="contact-header-left">
              <img src={logo} alt="logo" className="contact-logo" />
             
            </div>

            {/* DESCRIPTION */}
            <p className="contact-description">
              <strong>ПЗУ ЛУКС МЕДИКУС</strong> е овластена специјалистичка ординација по медицина на труд.
              Врши систематски прегледи, биохемиски анализи, клинички прегледи,
              хематолошки и уринарен статус и др.
            </p>

            <p className="contact-description">
              Ординацијата врши и прегледи на терен, со мобилна екипа која опслужува
              компании и пациенти во сите градови низ Македонија.
            </p>
<br/>
            {/* CONTACT ITEMS */}
            <div className="contact-item">
              <FaMapMarkerAlt className="icon" />
              <p>ул. Козле бр.88/4, Карпош, Скопје</p>
            </div>

            <div className="contact-item">
              <FaEnvelope className="icon" />
              <a href="mailto:luksmedicus@yahoo.com">
                luksmedicus@yahoo.com
              </a>
            </div>

            <div className="contact-item">
              <FaPhone className="icon" />
              <a href="tel:+38978882223">
                +389 78 882 223
              </a>
            </div>

            <div className="contact-item">
              <FaFacebookF className="icon" />
              <a
                href="https://www.facebook.com/luksmedikus"
                target="_blank"
                rel="noreferrer"
              >
                Лукс Медикус
              </a>
            </div>

          </div>

          {/* RIGHT MAP */}
          <div className="contact-map">
            <iframe
              src="https://www.google.com/maps?q=Kozle%2088%2F4%20Skopje&output=embed"
              loading="lazy"
              title="map"
            ></iframe>
          </div>

        </div>

      </div>
    </section>
  );
};

export default ContactUs;